import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { ConfigService } from '../common/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class NeedHelpService {
  constructor(
    private _httpInterceptor: HttpInterceptor,
    private _sessionHandler: SessionHandlerService
  ) { }
  public PostClickToCall(requestData: any): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.postLeadType;
    url = url.replace('{applicationId}', requestData.payload.applicationId);
    url = url.replace('{leadType}', requestData.payload.leadType);
    return this._httpInterceptor.Post(url, null);
  }

}
